export const GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_REQUEST = "GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_REQUEST";
export const GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_SUCCESS = "GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_SUCCESS";
export const GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_FAILURE = "GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_FAILURE";

export const GET_PATIENT_VIEW_DETAILS_REQUEST = "GET_PATIENT_VIEW_DETAILS_REQUEST";
export const GET_PATIENT_VIEW_DETAILS_SUCCESS = "GET_PATIENT_VIEW_DETAILS_SUCCESS";
export const GET_PATIENT_VIEW_DETAILS_FAILURE = "GET_PATIENT_VIEW_DETAILS_FAILURE";


const actionTypeAdmin = {
    GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_REQUEST,
    GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_SUCCESS,
    GET_DOCTERS_BY_PHONE_NUM_OR_EMAIL_FAILURE,

    GET_PATIENT_VIEW_DETAILS_REQUEST,
    GET_PATIENT_VIEW_DETAILS_SUCCESS,
    GET_PATIENT_VIEW_DETAILS_FAILURE
}
export default actionTypeAdmin;
